import React, { useState } from 'react';
import Select from 'react-select';
import CodeBlock from "@components/codeblock"

import '@theme/tooltip/master.css'

// The following is pretty self explanatory,
// however ensure that your codefield is wrapped in ""
// Otherwise React will not pick this up as a string and throw and error.

const options = [
    {
      value: 'Tooltip',
      label: 'tooltip',
      codeField:`
<div>
  <div id="nds-tooltip" class="nds_tool-label">Forename <button aria-expanded="false" class="nds-tool-trigger">?</button></div>
  <div id="nds-tool-pop" aria-hidden="true" data-floating-direction="bottom" class="nds-tool-pop">
    <span class="nds-tool__caret"></span>
    <div class="nds-tool__content" tabindex="-1" role="dialog">
      <p id="heading" class="nds-tool__heading">Header Copy</p>
      <p id="body" >Lorem ipsum dolor sit amet, consecetur adipiscing elit, sed do eiusmod tempor.</p>
    </div>
    <span tabindex="0"></span>
  </div>
</div>
`
    },
  ];

  const defaultSate = options[0].codeField


function TooltipStates() {
  //  Please ensure that your useState value contains the default value for your component
  // Otherwise nothing will show on initial render.
    const [selectedValue, setSelectedValue] = useState(defaultSate);
 
    const handleChange = e => {
      setSelectedValue(e.codeField);
    }

   
    return (
    <>
        <Select
         className="slDrp"
          placeholder="Select Option"
          value={options.filter(obj => obj.codeField === selectedValue)} // set selected value
          onChange={handleChange}
          options={options}
        />
        <CodeBlock lang="html" value={selectedValue} live={true}>{selectedValue}</CodeBlock>
    </>
    );
    }

export default TooltipStates